var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buttons-cover" }, [
    _c(
      "div",
      {
        staticClass: "default-button",
        class: { selectedPlanButton: (_vm.value || "annual") == "monthly" },
        on: {
          click: function ($event) {
            return _vm.changeSelectedPlan("monthly")
          },
        },
      },
      [_vm._v("\n        AYLIK\n    ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "default-button",
        class: { selectedPlanButton: (_vm.value || "annual") == "annual" },
        on: {
          click: function ($event) {
            return _vm.changeSelectedPlan("annual")
          },
        },
      },
      [
        _vm._v("\n        YILLIK "),
        _c("span", { staticClass: "free-months" }, [_vm._v("(İndirimli)")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }